import { DateTimeFormatter } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

function DateCell(props) {
  const { cell, type } = props;
  return cell.value ? (
    <DateTimeFormatter type="date" date={cell.value} />
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default DateCell;
